import React from 'react';
import SideMenuBar from '../../components/sideMenuBar';
import { useNavigate } from 'react-router-dom';
import { ACTIONS, KEYS, URLS } from '../../_config';
import { useDispatch } from 'react-redux';
import Icon from '../../components/icons';
import ReviewStat from './reviewStat';
import ReviewList from './reviewList';
import { DateRangePicker } from 'rsuite';
import "rsuite/dist/rsuite.css";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import moment from 'moment';
import Filter from '../../components/filter';
import Header from '../../components/header';
import { useFilterSelector } from '../../store/selectors/filterSelector';

const Reviews: React.FC = () => {
    const savedFilter = useFilterSelector();
    const filterValue = savedFilter.applied ?? {};

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleApplyFilter = (_filterData: any) => {
        // filter state is managed by Redux via Filter component
    };

    const handleClearFilter = () => {
        // filter state is managed by Redux via Filter component
    };

    return (
        <div className="flex">
            <SideMenuBar sideMenuBarClass={'w-64 h-screen bg-white '} />

            <div className="w-full bg-sky-50 overflow-y-auto" style={{ maxHeight: '100vh' }}>
                <Header />
                <div className="p-8">
                    <h1 className="text-xl font-semibold text-gray-600 mb-2">Reviews</h1>

                    {/* Paragraph */}
                    <p className="text-sm text-gray-600 mb-6 normal-case">
                        Complete review listings with sentiment classification and rating distribution insights.
                    </p>
                    <div className="flex justify-between mb-5 ipad-column">
                        <div className="flex-1 ipad-order-2">
                            <div className="bg-white shadow-lg rounded-2xl p-6 mb-5">
                                <ReviewStat filterValue={filterValue} />
                            </div>

                            <div className="bg-white shadow-lg rounded-2xl p-6">
                                <ReviewList filterValue={filterValue} />
                            </div>

                        </div>


                        <Filter
                            onApplyFilter={handleApplyFilter}
                            onClearFilter={handleClearFilter}
                            filterClass={'w-80 bg-white shadow-lg rounded-2xl p-6 ml-4 top-20 sticky h-[450px] ipad-static ipad-order-1 ipad-width-100 ipad-mb-2 '}
                        />
                    </div>

                </div>
            </div>
        </div>
    );
}
export default Reviews;